import { render, staticRenderFns } from "./IconPlayer.vue?vue&type=template&id=673515b2&"
import script from "./IconPlayer.vue?vue&type=script&lang=js&"
export * from "./IconPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('673515b2')) {
      api.createRecord('673515b2', component.options)
    } else {
      api.reload('673515b2', component.options)
    }
    module.hot.accept("./IconPlayer.vue?vue&type=template&id=673515b2&", function () {
      api.rerender('673515b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconPlayer.vue"
export default component.exports